import { defineStore } from 'pinia';

export const useTooltipFiStore = defineStore('tooltipFi', {
  state: (): {
    open: number | null;
    lastId: number;
  } => ({
    open: null,
    lastId: 0,
  }),
  actions: {
    getId(): number {
      return ++this.lastId;
    },
  },
});
